@if (item) {
  <button type="button"
    class="w-12"
    (click)="toggle()"
    >
    <div class="ratio-1-1">
      <img class="rf"
        [image]="item.sampleProduct.data.image">
      @if (selected) {
        <span
          class="pos-absolute top-3 right-3">
          <span class="ratio-1-1 w-12"
            style="width: 20px; height: 20px">
            <img class="rf"
              [imgHeight]="40"
              [imgWidth]="40"
              image="/assets/images/sample-tick.png">
            </span>
          </span>
        }
      </div>
      <p class="m-t-2 m-t-1-s w-12 left p2">{{item.sampleProduct.data.name}}</p>
    </button>
  }